import { useInfiniteQuery } from "react-query";
import { getCities } from "apis";

import { App } from "antd";
import { useTranslation } from "react-i18next";

export const useCities = ({ payload = {} }) => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useInfiniteQuery(
    ["cities", payload],
    async ({ pageParam = 0 }) => {
      let response;
      try {
        const {
          data: { data },
        } = await getCities({ page: pageParam, ...payload });
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    {
      getNextPageParam: (lastPage) => {
        if (!lastPage) {
          return undefined;
        }
        return lastPage.current_page < lastPage.last_page
          ? lastPage.current_page + 1
          : undefined;
      },
      keepPreviousData: true,
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
    }
  );
};
